module.exports = __webpack_public_path__ + "img/KC_DY.ebe71e6e.png";